import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ICriteria } from '../contracts/criteria.contract';

interface IInitialState {
    TrackerCriteria: ICriteria;
}

const initialState: IInitialState = {
    TrackerCriteria: {
        // Checkbox Values
        FishingVessel: false,
        SelfPropelled: false,
        RoRoVessel: false,
        RoRoVehicleCarrier: false,
        RoRoCargoShip: false,
        RoRoPassengerShip: false,
        HighSpeedCraft: false,
        MobileOffshoreDrillingUnit: false,
        PassengerShip: false,
        CruisePassenger: false,
        CargoShip: false,
        ContainerCarrier: false,
        GeneralCargoCarrier: false,
        RefrigeratedCargoCarrier: false,
        Tanker: false,
        OilTanker: false,
        ChemicalCarrier: false,
        GasLNGCarrier: false,
        LNGCarrier: false,
        NonLNGGasCarrier: false,
        CrudeTanker: false,
        ProductTanker: false,
        DynamicallySupportedCraft: false,
        BulkCarrier: false,
        CombinationCarrier: false,
        OreCarrier: false,
        OffshoreSupportVessel: false,
        Mandatory: false,
        Guideline: false,
        Hardware: false,
        Operational: false,
        Retroactive: false,
        New: false,
        IGFCode: false,
        MARPOL: false,
        SOLAS: false,
        STCW: false,
        AFS: false,
        ICLL: false,
        BWM: false,
        // Component Sliders
        GrossTonnage: null,
        NumberOfPassengers: null,
        Deadweight: null,
        LoadLineLength: null,
        LengthOverall: null,
        // Component Date Ranges
        EntryIntoForceBeforeDate: null,
        EntryIntoForceAfterDate: null,
        ContractBeforeDate: null,
        ContractAfterDate: null,
        KeelLayBeforeDate: null,
        KeelLayAfterDate: null,
        DeliveryBeforeDate: null,
        DeliveryAfterDate: null,
        ExpiryBeforeDate: null,
        ExpiryAfterDate: null,
        // User Input Text
        UserSearchQuery: ''
    }
};

const CriteriaSlice = createSlice({
    name: 'criteria',
    initialState: initialState,
    reducers: {
        SetCriteria: (state, action: PayloadAction<ICriteria>) => {
            state.TrackerCriteria = action.payload;
        }
    }
});

export const CriteriaAction = CriteriaSlice.actions;
export const CriteriaReducer = CriteriaSlice.reducer;
